/** extensions.code of a multicam save rejected because the set changed since it was loaded. */
export const MULTICAM_CONFLICT_CODE = 'MULTICAM_CONFLICT';

export const MULTICAM_CONFLICT_MESSAGE =
  'This multicam set was changed in another tab or by another device. Reload to see the latest version before saving.';

/** A multicam save refused by the server's optimistic-concurrency check. */
export class MulticamConflictError extends Error {
  readonly code = MULTICAM_CONFLICT_CODE;

  constructor(message: string = MULTICAM_CONFLICT_MESSAGE) {
    super(message);
    this.name = 'MulticamConflictError';
  }
}

export const isMulticamConflictError = (error: unknown): error is MulticamConflictError =>
  typeof error === 'object' && error !== null && (error as { code?: unknown }).code === MULTICAM_CONFLICT_CODE;
